import { useQuery } from '@tanstack/react-query'

import { request } from 'Lib/axios'
import { QueryConfig, ExtractFnReturnType } from 'Lib/react-query'
import { useUserStore } from 'Stores/userStoreModuleFed'
import { PlatformStatus } from 'Types/PlatformsConnections'

export type PlatformsResponse = {
  platforms: PlatformStatus[]
}

export const getPlatforms = async (
  accountId: number
): Promise<{ data: PlatformsResponse } | Error> => {
  return await request<{ data: PlatformsResponse }>({
    url: `/accounts/${accountId}/platforms`,
    method: 'GET',
  })
}

type QueryFnType = typeof getPlatforms

export const useGetPlatforms = ({ config }: { config?: QueryConfig<QueryFnType> } = {}) => {
  const { accountId } = useUserStore()
  const query = useQuery<ExtractFnReturnType<QueryFnType>>({
    queryKey: ['getPlatformsGW', accountId],
    queryFn: () => getPlatforms(accountId),
    ...config,
  })
  const data = query.data instanceof Error ? [] : query.data?.data.platforms

  return { ...query, data }
}
